import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { WorkoutState } from '../../types/course';

const initialState: WorkoutState = {
  isLoading: false,
  courseList: {},
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.COMPLEX },
};

const slice = createSlice({
  name: 'complex',
  initialState,
  reducers: {
    complexStartLoading(state) {
      state.isLoading = true;
    },

    complexHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    complexResetError(state) {
      state.error = undefined;
    },

    getComplexListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getComplexSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setComplexListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearComplex(state) {
      state.course = undefined;
    },

    clearComplexList(state) {
      state.courseList = {};
    },

    clearComplexParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  complexStartLoading,
  complexHasError,
  complexResetError,
  getComplexListSuccess,
  getComplexSuccess,
  setComplexListParams,
  clearComplex,
  clearComplexParameters,
  clearComplexList,
} = slice.actions;
